import React from "react";
import Image from "gatsby-image";

const Testimonial = ({ name, image, testimony, company }) => {
  return (
    <div className="testimonial">
      <Image fluid={image.childImageSharp.fluid} className="testimonial-img" />
      <div className="testimonial-card">
        <h4>{name}</h4>
        <div className="testimonial-footer">
          <p>{company}</p>
        </div>
        <p>" {testimony} "</p>
      </div>
    </div>
  );
};

export default Testimonial;
